import Layout from "src/layout";
import styled, { css } from "styled-components";
import { useBoundStore } from "src/store";
import { ReactNode, useEffect, useRef, useState } from "react";
import EditQcastStudio from "./EditQCastStudio";
import eventEmitter from "src/shared/utils/eventEmitter";
import toast from "react-hot-toast";
import { theme } from "src/styles/theme";

const RespondContainer = styled.div<{snapshot?: string}>`
    width: 100%;
    // height: 1002px;
    // background-color: #1a1a21;
    color: white;
    display: flex;
    flex-direction: column;
    border-top-left-radius: 20px;
    // background: linear-gradient(0deg, rgba(220, 214, 215, 0.48), rgba(0, 0, 0, 0.48)), linear-gradient(0deg, rgba(60, 61, 69, 0.16), rgba(19, 42, 131, 0.16));
    background: #E9E7E9;
    background-image: ${({ snapshot }) => `url(${snapshot})`};
    background-size: cover;
    background-position: center;
    position: relative;

    &::before {
        content: "";
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background: rgba(255, 255, 255, 0.1); /* Transparent overlay */
        backdrop-filter: blur(15px); /* Glass effect */
        -webkit-backdrop-filter: blur(15px);
        border-radius: 10px;
        box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1);
    }
    @media (max-width: ${theme.breakpoints.maxTablet}px) {
              height:100svh;
            }
`;

const Edit = () => {
    const [tempVideos, setTempVideos] = useState<any[]>([])
    
    const [videos, setVideos] = useState<{index: number, video: any, duration?: number}[]>([]);
    const { globalSettings, questions, recordedVideo, ffmpegInstance, loadVideo } = useBoundStore();
    const [currentVideoIndex, setCurrentVideoIndex] = useState<number>(0);

    const [snapshot, setSnapshot] = useState<string | null>(null);

    
    
    const handleCancel = () => {
    };
    
    const handleRecord = () => {
    };
    
    const handleVideoNavigation = (index: number) => {
        setCurrentVideoIndex(prev=>prev + index);
    }

    const handleSnapshot =(imageData: string) => {
        setSnapshot(imageData)
    }




    const getBlobFromDB=async(videoBlobId: string)=>{
        const blob: any = await loadVideo(videoBlobId);
        if (blob) {
          return blob.video;
        }
        return {};
    }
      
    
    useEffect(() => {
        const handleTranscriptionStart = () => {
        //   toast.success("Transcription started in background.");
        };
    
        const handleTranscriptionEnd = ({ success, error }: {success: boolean, error: string}) => {
            if(success){
                toast.success('Video transcription completed');
            }else{
                toast.error(`Transcription failed: ${error}`);
            }
        };
    
        eventEmitter.on('transcription-start', handleTranscriptionStart);
        eventEmitter.on('transcription-end', handleTranscriptionEnd);
    
        return () => {
          eventEmitter.off('transcription-start', handleTranscriptionStart);
          eventEmitter.off('transcription-end', handleTranscriptionEnd);
        };
    }, []);

    useEffect(() => {
    
        if (recordedVideo.length > 0) {
            (async () => {
                const updatedVideos: any = await Promise.all(
                    recordedVideo.map(async (video) => {
                        return {
                            ...video,
                            video: await getBlobFromDB(`${video.index}`),
                            editedBlob: await getBlobFromDB(`${video.index}-edited`),
                        };
                    })
                );
                setVideos(updatedVideos);
            })();
        }
    }, [recordedVideo]);

    
    return (
        <Layout>
            <RespondContainer snapshot={snapshot}>
                <EditQcastStudio videos={videos} ffmpeg={ffmpegInstance}  />
            </RespondContainer>
        </Layout>
    )
}

export default Edit;